import React from 'react';
import {
  Popover,
  Button,
  HoverStyles,
  ButtonPriority,
  TextButton,
  TextButtonPriority,
  PopoverTriggerAction,
} from 'wix-ui-tpa';
import {classes as st} from './PopoverWrapper.st.css';

export const PopoverWrapper = ({
  children,
  isMobile,
  setIsOpen,
  onChange,
  selectedCurrency,
  userCountryInfo,
  getTranslationByKey,
  sendBIEventOnButtonClick,
}: {
  children: React.ReactNode;
  isMobile: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onChange: (currency: string) => void;
  selectedCurrency: string;
  userCountryInfo: any;
  getTranslationByKey: (key: string, params?: Record<string, any>) => string;
  sendBIEventOnButtonClick: (status: boolean) => void;
}) => (
  <Popover
    triggerAction={PopoverTriggerAction.click}
    shown={true}
    placement="bottom-end"
    width={isMobile ? 170 : 300}
    className={st.popover}
    contentClassName={isMobile ? st.popoverContentForMobile : st.popoverContent}>
    <Popover.Element>{children}</Popover.Element>
    <Popover.Content>
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '100%',
          gap: '16px',
        }}>
        <Button
          style={{
            backgroundColor: 'black',
            color: 'white',
          }}
          priority={ButtonPriority.basic}
          hoverStyle={HoverStyles.underline}
          onClick={() => {
            setIsOpen(false);
            onChange(userCountryInfo?.currency);
            localStorage.setItem('selectedCurrency', userCountryInfo?.currency);
            sendBIEventOnButtonClick(true);
          }}>
          {getTranslationByKey('currencyConverter.dropdown.defaultCurrency.switch-to', {
            currency: userCountryInfo?.currency,
            flag: userCountryInfo?.flagEmoji,
          })}
        </Button>
        <TextButton
          style={{
            color: 'black',
          }}
          priority={TextButtonPriority.link}
          hoverStyle={HoverStyles.underline}
          onClick={() => {
            setIsOpen(false);
            sendBIEventOnButtonClick(false);
          }}>
          {getTranslationByKey('currencyConverter.dropdown.defaultCurrency.keep', {
            currency: selectedCurrency,
          })}
        </TextButton>
      </div>
    </Popover.Content>
  </Popover>
);
